import { isNil } from '@sixfold/typed-primitives';

import { EmbedData, EmbedConfig } from '../../../shared/types';

declare global {
  interface Window {
    __EMBED_DATA__?: string;
    __EMBED_CONFIG__?: string;
  }
}

export const getEmbedData = (): EmbedData => {
  const embedData = window.__EMBED_DATA__;
  if (isNil(embedData)) {
    console.error('Could not load embed data');
    return {};
  }

  return JSON.parse(Buffer.from(embedData, 'base64').toString()) as EmbedData;
};

export const getEmbedConfig = (): EmbedConfig | null => {
  const embedConfig = window.__EMBED_CONFIG__;
  if (isNil(embedConfig)) {
    console.error('Could not load embed config');
    return null;
  }

  return JSON.parse(Buffer.from(embedConfig, 'base64').toString()) as EmbedConfig;
};
